import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  token: null,
  email: null,  // 添加email字段
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.email = action.payload.email;  // 存储email
    },
    logout(state) {
      state.isLoggedIn = false;
      state.token = null;
      state.email = null;  // 清空email
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
